import * as React from 'react';

import {DonutChart} from 'shells/charts/donut-chart';
import type {Item} from 'shells/table/item-count-table';

import {CompetitorsDonutChartTooltip} from '.';

import styles from '../competitors.module.css';

type Props = {
    width: number;
    domains: Item[];
};

export function TrafficDonutChart(props: Props) {
    return (
        <div className={styles['donut-chart-container']}>
            <DonutChart
                width={props.width}
                items={props.domains}
                singularNoun='visitor'
                pluralNoun='visitors'
                customTooltip={CompetitorsDonutChartTooltip}
            />
        </div>
    );
}
